/**
 * @generated SignedSource<<ddf7c9994f9fda939e9c43a4bd9f5dc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type shareArticle20Content$data = {
  readonly " $fragmentSpreads": FragmentRefs<"popupArticle20ShareMenuContent">;
  readonly " $fragmentType": "shareArticle20Content";
};
export type shareArticle20Content$key = {
  readonly " $data"?: shareArticle20Content$data;
  readonly " $fragmentSpreads": FragmentRefs<"shareArticle20Content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "shareArticle20Content",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "popupArticle20ShareMenuContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "de5dfe911ddd66b059bedfc785545ceb";

export default node;
